

export const responses = {
  greeting: [
    "👋 How can I help you with your digital marketing today?",
    "Ready to boost your marketing strategy? Ask away!"
  ],
  marketing: [
    "Let's optimize your marketing strategy. What's your main goal?",
    "I can help with SEO, social media, content strategy, PPC, or analytics. What interests you?"
  ],
  services: [
    `•	Web Development: Crafting responsive, visually stunning, and user-friendly websites tailored to your brand.
•	Search Engine Optimization (SEO): Enhancing your online visibility and driving organic traffic with proven SEO strategies.
•	Social Media Marketing: Building your brand's presence on social media platforms with creative content and targeted campaigns.
•	Digital Designing: Designing eye-catching graphics, logos, and marketing materials to elevate your brand identity.`

  ],
  seo: [
    "SEO is crucial! Need help with keywords, rankings, or backlinks?",
    "Let's improve your search visibility. What's your focus? Keywords, on-page SEO, or technical SEO?"
  ],
  social: [
    "Which platform do you want to optimize? Facebook, Instagram, LinkedIn, or TikTok?",
    "Need help with content strategy, engagement, or social media ads?"
  ],
  content: [
    "Content is king! Need help with blog posts, videos, or infographics?",
    "Let's create a content strategy. What type of content are you focusing on?"
  ],
  ppc: [
    "PPC can drive quick results. Need help with Google Ads, Facebook Ads, or retargeting?",
    "Let's optimize your ad campaigns. What's your budget and target audience?"
  ],
  analytics: [
    "Data-driven decisions are key. Need help with Google Analytics, tracking, or reporting?",
    "Let's analyze your performance. What metrics are you tracking?"
  ],
  email: [
    "Email marketing is powerful. Need help with campaigns, automation, or segmentation?",
    "Let's boost your email strategy. What's your goal: engagement or conversions?"
  ],
  keywords: [
    "Keywords are the foundation of SEO. Need help with research, long-tail keywords, or LSI keywords?",
    "Let's find the best keywords for your niche. What's your target audience?"
  ],
  backlinks: [
    "Backlinks are essential for SEO. Need help with link building, outreach, or guest posting?",
    "Let's improve your domain authority. What's your current backlink strategy?"
  ],
  branding: [
    "Branding sets you apart. Need help with identity, messaging, or positioning?",
    "Let's build a strong brand. What's your unique value proposition?"
  ],
  conversion: [
    "Conversions are the ultimate goal. Need help with CRO, landing pages, or A/B testing?",
    "Let's optimize your conversion rate. What's your current funnel?"
  ],
  influencer: [
    "Influencer marketing can amplify your reach. Need help with partnerships or campaigns?",
    "Let's find the right influencers for your brand. What's your niche?"
  ],
  video: [
    "Video content is highly engaging. Need help with YouTube, TikTok, or video ads?",
    "Let's create a video strategy. What's your target platform?"
  ],
  mobile: [
    "Mobile optimization is a must. Need help with responsive design or app marketing?",
    "Let's improve your mobile presence. What's your focus: apps or mobile ads?"
  ],
  local: [
    "Local SEO can drive foot traffic. Need help with Google My Business or local listings?",
    "Let's optimize for local searches. What's your target area?"
  ],
  ecommerce: [
    "E-commerce marketing is unique. Need help with product listings, Shopify, or Amazon?",
    "Let's boost your online store. What's your main challenge?"
  ],
  webdevlopment: [
    "Automation saves time. Need help with CRM, email automation, or chatbots?",
    "Let's streamline your processes. What tools are you using?"
  ],
  trends: [
    "Stay ahead with trends. Need help with AI marketing, voice search, or AR/VR?",
    "Let's explore the latest in digital marketing. What's your interest?"
  ],
  default: [
    "Could you tell me more about your marketing needs?",
    "I specialize in digital marketing strategy. What area interests you?"
  ],
  about: [
      `"Welcome to Pixel Meta Lab, where creativity meets strategy to 
      deliver impactful digital solutions. We are a passionate team of innovators, 
      designers, and marketers dedicated to transforming your online presence and driving 
      measurable results."`,

  ],
  contact: [
    `"Let's connect and discuss your project. What's your preferred method of contact? \n
      Name :  Pixel Meta Lab \n
      Phone:  +94 7669223983 \n
      Email:  hello@pixelmetalab.com \n
      Address: No.88 B1/1, S.De S Jayasinghe Mawatha,Kohuwala
    "`,
    `"I'd love to hear from you. What's your current pain point or goal? \n
     \n Name :  Pixel Meta Lab 
    \n  Phone:  +94 7669223983 \n
      \n Email:  hello@pixelmetalab.com \n
     \n Address: No.88 B1/1, S.De S Jayasinghe Mawatha,Kohuwala
    
    "`,
],
pricing: [
  "I'd be happy to share our pricing plans! Which service interests you? We offer:\n1. Web Development\n2. SEO Services\n3. Branding Services\n4. Digital Marketing",
  "Let me help you with pricing information! What type of service are you looking for? We have plans for:\n1. Web Development\n2. SEO Services\n3. Branding Services\n4. Digital Marketing"
],

webPricing: [
  `Here are our Web Development packages:\n
  1. Basic Website ($1,000):
     • Up to 5 pages
     • Mobile-friendly design
     • Basic SEO setup
     • 1 round of revisions\n
  2. Standard Website ($2,500):
     • Up to 10 pages
     • Custom design
     • SEO optimization
     • CMS integration
     • 2 rounds of revisions\n
  3. E-commerce Website ($5,000+):
     • Product catalog setup
     • Payment gateway integration
     • Custom design
     • SEO and analytics setup
     • 3 rounds of revisions\n
  Would you like to know more about any specific package?`
],

seoPricing: [
  `Here are our SEO Service packages:\n
  1. Starter SEO ($500/month):
     • Keyword research
     • On-page SEO optimization
     • Monthly performance report\n
  2. Advanced SEO ($1,000/month):
     • Comprehensive keyword research
     • On-page and technical SEO
     • Backlink building
     • Monthly strategy call\n
  3. Enterprise SEO (Custom Pricing):
     • Dedicated SEO manager
     • Custom strategies for large websites
     • Advanced analytics and reporting
     • Competitor analysis\n
  Which package would you like to learn more about?`
],

brandingPricing: [
  `Here are our Branding Service packages:\n
  1. Logo Design ($300):
     • 3 initial concepts
     • 2 rounds of revisions
     • Final logo in multiple formats\n
  2. Brand Identity Package ($1,000):
     • Logo design
     • Color palette and typography
     • Business card and letterhead design
     • Brand style guide\n
  3. Full Branding Package ($2,500):
     • Logo and brand identity
     • Social media assets
     • Marketing collateral design
     • Comprehensive brand strategy\n
  Would you like details about any specific package?`
],

marketingPricing: [
  `Here are our Digital Marketing packages:\n
  1. Social Media Management ($500/month):
     • Content creation for 3 platforms
     • Post scheduling and management
     • Monthly performance report\n
  2. PPC Campaigns ($750/month + Ad Spend):
     • Campaign setup and management
     • Ad copy and design
     • Performance tracking\n
  3. Full Digital Marketing Package ($2,000/month):
     • Social media management
     • PPC campaigns
     • Email marketing
     • Monthly analytics report\n
  Which package interests you?`
],
faq: [
  {
    "question": "What is your company’s mission?",
    "answer": "Our mission is to empower businesses by enhancing their online presence and driving measurable growth through innovative SEO, website development, and brand marketing solutions."
  },
  {
    "question": "What is your company’s name?",
    "answer": "Company name is Pixel Meta Lab."
  },
  {
    "question": "What is your company’s contact number?",
    "answer": "Company contact number is +94 769223983."
  },
  {
    "question": "What is your company’s email address?",
    "answer": "Company email address is hello@pixelmetalab.com"
  },
  {
    "question": "How long has your company been in business?",
    "answer": "We’ve been helping businesses grow their digital presence for 5 years. Our team has extensive experience in the industry and has worked with a variety of clients across multiple sectors."
  },
  {
    "question": "Where is your company located?",
    "answer": "We are based in No.88 B1/1, S.De S Jayasinghe Mawatha,Kohuwala, but we work with clients locally and internationally, thanks to our fully digital and collaborative process."
  },
  {
    "question": "What sets your company apart from competitors?",
    "answer": "We focus on personalized solutions, transparent communication, and measurable results. Unlike others, we treat every client as a partner, ensuring our strategies align perfectly with your goals."
  },
  {
    "question": "Who is on your team?",
    "answer": "Our team includes experienced SEO specialists, skilled web developers, creative brand marketers, and dedicated support staff. Together, we bring a wealth of expertise to your projects."
  },
  {
    "question": "What industries do you specialize in?",
    "answer": "While we work with businesses across all industries, we have extensive experience in e-commerce, healthcare, real estate, technology, and more."
  },
  {
    "question": "Can I see examples of your previous work?",
    "answer": "Absolutely! We have a portfolio showcasing some of our successful projects. Let us know, and we’d be happy to share relevant examples that match your industry or goals."
  },
  {
    "question": "Do you offer consultations?",
    "answer": "Yes, we offer free initial consultations to discuss your needs, challenges, and goals. This helps us determine the best strategies to help your business grow."
  },
  {
    "question": "Are your services scalable for small and large businesses?",
    "answer": "Yes, we work with businesses of all sizes. Our solutions are tailored to meet the unique needs of small startups, medium-sized companies, and large enterprises."
  },
  {
    "question": "How do you ensure client satisfaction?",
    "answer": "We prioritize clear communication, regular updates, and results-driven strategies. Your success is our success, and we go above and beyond to exceed expectations."
  },
  {
    "question": "How can SEO help my business?",
    "answer": "SEO helps improve your website's visibility on search engines like Google, driving more organic traffic and potential customers to your site. It can also establish your authority in your industry."
  },
  {
    "question": "How long does it take to see results from SEO?",
    "answer": "SEO is a long-term strategy. While you might see some improvements in 2-3 months, significant results typically take 6-12 months, depending on your industry and competition."
  },
  {
    "question": "What SEO services do you offer?",
    "answer": "Our SEO services include keyword research, on-page and off-page optimization, technical SEO, content creation, and regular performance tracking."
  },
  {
    "question": "Can you guarantee first-page rankings on Google?",
    "answer": "While no one can guarantee first-page rankings, we use proven strategies to significantly improve your site's visibility and ranking potential."
  },
  {
    "question": "What kind of websites do you build?",
    "answer": "We build all kinds of websites, including corporate sites, e-commerce stores, blogs, and custom platforms tailored to your needs. Our sites are responsive, fast, and SEO-friendly."
  },
  {
    "question": "How long does it take to build a website?",
    "answer": "Depending on the complexity, most websites take 4-8 weeks to design and develop. We provide a clear timeline during the planning phase."
  },
  {
    "question": "Will I be able to update my website after it’s built?",
    "answer": "Yes, we use user-friendly content management systems (like WordPress) so you can easily update your site. We also offer training and ongoing support if needed."
  },
  {
    "question": "Can you redesign my existing website?",
    "answer": "Absolutely! We can revamp your current site to improve its functionality, design, and performance while ensuring it aligns with your brand."
  },
  {
    "question": "What is brand marketing, and why is it important?",
    "answer": "Brand marketing involves creating a strong, consistent identity that resonates with your target audience. It builds trust, loyalty, and recognition, which are essential for long-term success."
  },
  {
    "question": "What brand marketing services do you provide?",
    "answer": "We offer logo design, brand strategy development, social media marketing, content creation, and campaigns to help you connect with your audience."
  },
  {
    "question": "How do you measure the success of a branding campaign?",
    "answer": "Success is measured by increased brand awareness, engagement rates, website traffic, and conversion rates. We provide detailed reports to track these metrics."
  },
  {
    "question": "Can you help with social media marketing?",
    "answer": "Yes, we create and manage campaigns across platforms like Facebook, Instagram, LinkedIn, and Twitter to boost your online presence and engage your audience."
  },
  {
    "question": "How much do your services cost?",
    "answer": "Our pricing depends on the scope of the project. We offer customized packages based on your specific needs. Contact us for a free consultation and quote."
  },
  {
    "question": "Do you offer any discounts for bundled services?",
    "answer": "Yes, we provide discounted rates for clients who combine services like SEO, website development, and brand marketing into one package."
  },
  {
    "question": "Are there any hidden fees?",
    "answer": "No, we provide transparent pricing with no hidden fees. All costs are outlined upfront in our proposal."
  },
  {
    "question": "Do you provide ongoing support?",
    "answer": "Yes, we offer ongoing support for all our services, including website maintenance, SEO monitoring, and campaign management."
  },
  {
    "question": "What happens if I encounter issues after my website is launched?",
    "answer": "We provide a support period after launch to address any issues. For long-term support, we offer affordable maintenance plans."
  },
  {
    question: "What is SEO?",
    answer: "SEO (Search Engine Optimization) is the process of improving your website's visibility on search engines like Google, driving more organic traffic, and increasing your site's ranking for relevant keywords."
  },
  {
    question: "Why is SEO important for my business?",
    answer: "SEO helps potential customers find your business online, increases brand credibility, and drives long-term organic traffic, reducing the need for heavy reliance on paid ads."
  },
  {
    question: "How much do your SEO services cost?",
    answer: "At Pixel Meta Lab, our SEO services start at $500/month for basic packages and go up depending on the scope of work, competition, and your goals."
  },
  {
    question: "Do you offer custom pricing for SEO services?",
    answer: "Yes! Pixel Meta Lab creates tailored packages based on your business needs, industry, and budget."
  },
  {
    question: "What’s included in your SEO packages?",
    answer: "Pixel Meta Lab's SEO packages typically include keyword research, on-page optimization, technical audits, backlink building, content creation, and monthly performance reports."
  },
  {
    question: "Do you offer local SEO services?",
    answer: "Yes! Pixel Meta Lab specializes in optimizing your Google My Business profile, targeting local keywords, and improving local citations to help your business rank better in local search results."
  },
  {
    question: "How long does it take to see SEO results?",
    answer: "SEO is a long-term strategy. With Pixel Meta Lab, results can start showing in 3-6 months, but significant improvements may take 6-12 months, depending on competition and industry."
  },
  {
    question: "Can you help with technical SEO?",
    answer: "Absolutely! Pixel Meta Lab conducts technical audits to fix issues like site speed, mobile usability, crawl errors, and structured data implementation."
  },
  {
    question: "How do you measure SEO success?",
    answer: "Pixel Meta Lab measures SEO success using metrics like organic traffic, keyword rankings, click-through rates (CTR), and conversion rates. We provide regular performance reports."
  },
  {
    question: "Do you offer discounts for long-term commitments?",
    answer: "Yes! Pixel Meta Lab provides discounts for 6-month and 12-month contracts to reward long-term partnerships."
  },
  {
    question: "Why should I choose Pixel Meta Lab for SEO?",
    answer: "Pixel Meta Lab combines technical expertise, innovative strategies, and personalized solutions to deliver measurable results for your business. We prioritize transparency and client satisfaction."
  },
  {
    question: "Can Pixel Meta Lab help with other digital marketing services?",
    answer: "Yes! Pixel Meta Lab offers a range of services, including web development, brand marketing, social media management, and content creation, to complement your SEO efforts."
  },
  {
    question: "What is SEO?",
    answer: "SEO stands for Search Engine Optimization. It’s about making your website more visible on Google so more people can find you."
  },
  {
    question: "Why do I need SEO?",
    answer: "If people can’t find your business online, they can’t become your customers. SEO helps your website rank higher and get more traffic."
  },
  {
    question: "How can Pixel Meta Lab help with SEO?",
    answer: "At Pixel Meta Lab, we use smart strategies like keyword research, content optimization, and link building to boost your website’s visibility."
  },
  {
    question: "How long does SEO take to work?",
    answer: "SEO isn’t instant—it’s a long-term game. You’ll usually see results in 3-6 months, and Pixel Meta Lab will guide you every step of the way."
  },
  {
    question: "Is SEO expensive?",
    answer: "It doesn’t have to be! Pixel Meta Lab offers SEO plans starting at just $500/month, customized to fit your budget and goals."
  },
  {
    question: "Do you offer local SEO?",
    answer: "Yes, we do! Pixel Meta Lab can help your business show up in local searches, like 'coffee shop near me' or 'plumber in [your city]'."
  },
  {
    question: "Can you improve my current website's SEO?",
    answer: "Absolutely! Pixel Meta Lab will audit your website and fix issues like slow speed, missing keywords, or broken links."
  },
  {
    question: "What makes Pixel Meta Lab different?",
    answer: "We don’t just work for you—we partner with you. Pixel Meta Lab focuses on real results, like higher rankings and more traffic, not just fancy reports."
  },
  {
    question: "What’s the first step to getting started?",
    answer: "Just reach out to us at Pixel Meta Lab! We’ll set up a free consultation to learn about your goals and create a plan."
  },
  {
    question: "What types of websites does Pixel Meta Lab build?",
    answer: "Pixel Meta Lab builds a variety of websites, including corporate websites, e-commerce stores, blogs, portfolios, and custom platforms tailored to your business needs."
  },
  {
    question: "How much does a website cost at Pixel Meta Lab?",
    answer: "The cost depends on the complexity and features of the website. Our web development packages start at $1,000 for basic websites and go up for more advanced functionalities."
  },
  {
    question: "How long does it take to build a website?",
    answer: "At Pixel Meta Lab, most websites are completed within 4-8 weeks, depending on the scope and requirements of the project."
  },
  {
    question: "Will I be able to update my website after it’s built?",
    answer: "Yes! Pixel Meta Lab uses user-friendly content management systems (like WordPress) so you can easily update your website. We also provide training and ongoing support if needed."
  },
  {
    question: "Do you offer website redesign services?",
    answer: "Absolutely! Pixel Meta Lab specializes in revamping existing websites to improve design, functionality, and performance while aligning with your brand identity."
  },
  {
    question: "Do your websites include SEO optimization?",
    answer: "Yes, all websites built by Pixel Meta Lab are optimized for search engines. We ensure proper structure, fast loading times, and mobile responsiveness to improve your website's ranking potential."
  },
  {
    question: "Can you integrate third-party tools into my website?",
    answer: "Yes, Pixel Meta Lab can integrate various third-party tools, such as payment gateways, CRM systems, analytics platforms, and marketing tools, to enhance your website's functionality."
  },
  {
    question: "Do you provide e-commerce website development?",
    answer: "Yes! Pixel Meta Lab builds e-commerce websites with platforms like Shopify, WooCommerce, and custom solutions to help you sell your products online effectively."
  },
  {
    question: "What is included in your web development packages?",
    answer: "Our packages typically include website design, development, mobile responsiveness, basic SEO setup, and post-launch support. Custom features can be added based on your needs."
  },
  {
    question: "Why should I choose Pixel Meta Lab for web development?",
    answer: "Pixel Meta Lab delivers visually stunning, responsive, and user-friendly websites tailored to your brand. Our team combines creativity and technical expertise to ensure your website stands out."
  },
  {
    question: "Do you provide ongoing maintenance and support?",
    answer: "Yes, Pixel Meta Lab offers affordable maintenance plans to ensure your website remains secure, updated, and performing optimally after launch."
  },
  {
    question: "Can Pixel Meta Lab handle large-scale web development projects?",
    answer: "Absolutely! Pixel Meta Lab has the expertise and resources to handle projects of all sizes, from small business websites to large-scale enterprise platforms."
  },
  {
    question: "What kind of websites do you build?",
    answer: "We build all kinds of websites! From simple business sites to online stores and custom platforms, Pixel Meta Lab can do it all."
  },
  {
    question: "How much does a website cost?",
    answer: "It depends on what you need. Our prices start at $1,000 for basic websites. For something more advanced, we’ll create a custom plan just for you."
  },
  {
    question: "How long does it take to make a website?",
    answer: "Most websites take 4-8 weeks, depending on how complex it is. Don’t worry—Pixel Meta Lab will keep you updated every step of the way."
  },
  {
    question: "Can I update my website after it’s built?",
    answer: "Of course! We use tools like WordPress so you can easily make changes. And if you need help, Pixel Meta Lab is always here to support you."
  },
  {
    question: "Do you offer e-commerce websites?",
    answer: "Yes! We can build online stores with platforms like Shopify or WooCommerce, or even custom solutions for your business."
  },
  {
    question: "What’s included in your web development packages?",
    answer: "Our packages include everything you need: design, development, mobile-friendly layouts, basic SEO, and support after launch."
  },
  {
    question: "Can you redesign my current website?",
    answer: "Absolutely! If your website feels outdated or isn’t working well, Pixel Meta Lab can give it a fresh, modern look."
  },
  {
    question: "Do you provide ongoing support?",
    answer: "Yes, we offer affordable maintenance plans to keep your website secure, updated, and running smoothly."
  },
  {
    question: "Why should I choose Pixel Meta Lab?",
    answer: "Because we care about your success! Pixel Meta Lab combines creativity and technical expertise to deliver websites that look amazing and perform even better."
  },
  {
    question: "How do I get started?",
    answer: "It’s easy! Just contact Pixel Meta Lab, and we’ll set up a free consultation to talk about your needs and goals."
  },
  {
    question: "Tell me about Pixel Meta Lab",
    answer: "We're Pixel Meta Lab, a creative digital agency passionate about helping businesses grow online. We specialize in web development, SEO, and digital marketing - basically everything you need to succeed in the digital world! What would you like to know more about?"
  },
  {
    question: "What makes Pixel Meta Lab different from other agencies?",
    answer: "What sets us apart is our personalized approach - we're not just another agency, we're your digital growth partner! We combine creative expertise with data-driven strategies, and we're proud of our transparent communication and measurable results. Plus, we actually take the time to understand your business before suggesting solutions. Would you like to hear about some of our success stories?"
  },

  // Services Overview
  {
    question: "What services do you offer?",
    answer: "We offer a complete digital solution package! Our main services include: \n• Web Development (starting at $1,000)\n• SEO Services (from $500/month)\n• Digital Marketing (custom packages)\n• Brand Development\n• Social Media Management\n\nWhich of these interests you? I'd be happy to provide more details about any specific service!"
  },

  // Web Development Details
  {
    question: "Tell me about your web development services",
    answer: "Our web development packages start at $1,000 and include:\n• Custom responsive design\n• Mobile optimization\n• Basic SEO setup\n• Content management system\n• Security features\n\nFor e-commerce sites, prices start at $2,000. Each project is unique, so we can customize based on your needs. Would you like to discuss your specific requirements?"
  },
  {
    question: "How long does it take to build a website?",
    answer: "Typically, we complete websites in 4-8 weeks. A basic business website usually takes 4 weeks, while more complex e-commerce sites might take 6-8 weeks. We'll provide you with a detailed timeline during our initial consultation. Would you like to know what's involved in each phase?"
  },

  // SEO Services
  {
    question: "What are your SEO services and pricing?",
    answer: "Our SEO packages start at $500/month and include:\n• Keyword research\n• On-page optimization\n• Technical SEO\n• Monthly reporting\n• Content optimization\n\nPremium packages ($1,000+/month) add:\n• Link building\n• Content creation\n• Competitor analysis\n• Local SEO\n\nShall we discuss which package might be right for your business?"
  },
  {
    question: "How long does it take to see SEO results?",
    answer: "You'll typically start seeing initial improvements in 3-4 months, with significant results in 6-12 months. We provide monthly progress reports so you can track every improvement. Want to know what results you can expect in your specific industry?"
  },

  // Digital Marketing
  {
    question: "What are your digital marketing packages?",
    answer: "Our digital marketing packages are customized based on your needs, but typically include:\n• Basic Package ($800/month): Social media management + basic content marketing\n• Growth Package ($1,500/month): Adds email marketing + PPC management\n• Premium Package ($2,500+/month): Full-service digital marketing\n\nWould you like to hear what's included in each package in detail?"
  },

  // Contact Information
  {
    question: "How can I get in touch with you?",
    answer: "We'd love to hear from you! You can:\n• Call us: +94 769223983\n• Email: hello@pixelmetalab.com\n• Visit: No.88 B1/1, S.De S Jayasinghe Mawatha, Kohuwala\n\nWould you like to schedule a free consultation call?"
  },

  // Process and Next Steps
  {
    question: "How do we get started?",
    answer: "Getting started is easy! First, we'll have a free consultation call to understand your needs. Then we'll provide a custom proposal with pricing and timeline. Once approved, we can kick off within a week. Would you like to schedule that initial consultation?"
  },
  {
    question: "Do you offer any discounts?",
    answer: "Yes! We offer:\n• 10% off for 6-month commitments\n• 15% off for annual contracts\n• Special startup packages\n• Bundle discounts when combining services\n\nWould you like to know which discount would work best for your needs?"
  },
  {
    question: "How much does web development cost?",
    answer: "Our web development prices start at $1,000 for basic websites. For more advanced features, we’ll create a custom plan tailored to your needs. Contact Pixel Meta Lab for a detailed quote!"
  },
  {
    question: "What’s the cost of SEO services?",
    answer: "Our SEO packages start at $500/month. We offer customized plans based on your goals and budget. Let Pixel Meta Lab help boost your online visibility!"
  },
  {
    question: "How much does branding cost?",
    answer: "Branding services, like logo design and brand strategy, start at $300. Pixel Meta Lab can create a unique package to suit your business."
  },
  {
    question: "What are the prices for your services?",
    answer: "Our pricing depends on the service and your specific needs. For web development, SEO, branding, or other services, contact Pixel Meta Lab for a free consultation!"
  },
  {
    question: "Do you offer discounts or special deals?",
    answer: "Yes! Pixel Meta Lab offers discounts for bundled services and long-term contracts. Reach out to learn about our current promotions."
  },
  {
    question: "Can I get a custom quote for my project?",
    answer: "Absolutely! Pixel Meta Lab provides free consultations to discuss your project and give you a custom quote. Let’s talk about your goals!"
  },
  {
    question: "How do I contact Pixel Meta Lab?",
    answer: "You can reach us at: \n- **Phone**: +94 769223983 \n- **Email**: hello@pixelmetalab.com \n- **Address**: No.88 B1/1, S.De S Jayasinghe Mawatha, Kohuwala."
  },
  {
    question: "Where is Pixel Meta Lab located?",
    answer: "Pixel Meta Lab is based at No.88 B1/1, S.De S Jayasinghe Mawatha, Kohuwala. We work with clients locally and internationally."
  },
  {
    question: "Do you offer free consultations?",
    answer: "Yes, Pixel Meta Lab offers free consultations to understand your needs and create a plan that works for you. Call us today at +94 7669223983!"
  },
  {
    question: "How much for a website?",
    answer: "Websites start at $1,000. If you need more features, we’ll make a plan that fits your budget. Let’s chat about it!"
  },
  {
    question: "What’s the price for SEO?",
    answer: "SEO starts at $500/month. We can customize a plan to help your business rank higher on Google. Contact us for details!"
  },
  {
    question: "How much for branding?",
    answer: "Branding, like logo design or strategy, starts at $300. We can bundle services to save you money too!"
  },
  {
    question: "What are your prices?",
    answer: "It depends on what you need. For websites, SEO, or branding, we offer flexible pricing. Let’s talk and figure it out together!"
  },
  {
    question: "Do you have discounts?",
    answer: "Yes! We offer discounts for bundled services or long-term contracts. Ask us about our current deals!"
  },
  {
    question: "Can I get a quote?",
    answer: "Of course! We offer free quotes for all our services. Just reach out, and we’ll give you a clear idea of the cost."
  },
  {
    question: "How do I contact you?",
    answer: "You can reach Pixel Meta Lab at: \n- **Phone**: +94 769223983 \n- **Email**: hello@pixelmetalab.com \n- **Address**: No.88 B1/1, S.De S Jayasinghe Mawatha, Kohuwala."
  },
  {
    question: "Where are you located?",
    answer: "We’re in Kohuwala, but we work with clients all over the world. Let’s connect and see how we can help!"
  },
  {
    question: "Do you offer free consultations?",
    answer: "Yes! Let’s discuss your goals and how we can help. Call us at +94 769223983 to book your free consultation."
  },
  {
    question: "What are your prices?",
    answer: "We offer various services with different pricing tiers. Which service interests you most? We have:\n1. Web Development (from $1,000)\n2. SEO Services (from $500/month)\n3. Branding Services (from $300)\n4. Digital Marketing (from $500/month)\n\nI can provide detailed pricing for any of these services!"
  },
  {
    question: "How much does a website cost?",
    answer: "Our website development packages start at $1,000 for a basic website, $2,500 for a standard website, and $5,000+ for e-commerce websites. Each package includes different features and services. Would you like to know what's included in each package?"
  },
  {
    question: "What are your SEO package prices?",
    answer: "Our SEO packages start at $500/month for basic optimization, $1,000/month for advanced SEO, and we also offer custom enterprise solutions. Each tier includes different features and services. Would you like me to break down what's included in each package?"
  },
  {
    question: "How much do branding services cost?",
    answer: "Our branding services range from $300 for logo design, $1,000 for a brand identity package, to $2,500 for a full branding package. Would you like to know what's included in each option?"
  },
  {
    question: "What are your digital marketing rates?",
    answer: "Our digital marketing services start at $500/month for social media management, $750/month for PPC campaigns, and $2,000/month for a full digital marketing package. Would you like to learn more about what's included in each package?"
  },
  {
    question: "Do you offer package discounts?",
    answer: "Yes! We offer several ways to save:\n• 10% off for 6-month commitments\n• 15% off for annual contracts\n• Bundle discounts when combining multiple services\n• Custom packages for startups\n\nWould you like to discuss which discount would work best for your needs?"
  }
]

};